import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Loadersspinners from "./Loaders/LoadersSpinners";
import { useSelector, useDispatch } from "react-redux";
import { cartItem } from "../features/cartdata";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link ,useNavigate} from "react-router-dom";
import { useSnackbar } from "notistack";
import { Baseurl } from "../../src/constants/env";
import   './Products.scss'
import { Dropdown } from 'bootstrap';
import Banner from "./banner/Banner";
import Tempfooter from "./Tempfooter";
import io from 'socket.io-client';
import Countdown from "./Countdown";
import Slider from "react-slick";
import QuillTextDisplay from "./common/QuillTextDisplay";
import { StarIcon } from "lucide-react";

const Products = () => {
  const SOCKET_ENDPOINT = 'http://localhost:5001';
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [categ, setCateg] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  let [loading, setLoading] = useState(false);
  let [error, seterror] = useState(false);
  const { userid } = useSelector((state) => state.auth);
  const [searchCategory, setSearchCat] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemSet, setSelectedItemSet] = useState(new Set());
  const [socket, setSocket] = useState(null);
  const [dealdata, setDealdata] = useState([]);
  const [timeRemaining, setTimeRemaining] = useState(null);
    const [dealStarted, setDealStarted] = useState(false);
    const [startDate, setStartDate] = useState() 
    const [branddata, setBranddata] = useState([]) 
    const [contry,setContry] = useState([])


const [endDate, setEnddate] = useState() 
 
const Navigate = useNavigate()
  useEffect(() => {
    getprodutsdata();
   return () => getprodutsdata()
  }, []);

  const handleSelectUser = (prod) => {
    setSelectedItems([...selectedItems, prod ])
    // setSelectedItemSet(new Set([...selectedItemSet, prod._id]))
    setSuggestions([])
    if( searchTerm == ""){
      return
    }
    setSearchTerm(prod.name)
   
  };

  const fetchSearchQuery = async () => {  
    if (searchTerm.trim() === "") {
      setSuggestions([]);
      return;
    }
    let result = await axios(`${Baseurl}/products?q=${searchTerm}&c=${searchCategory.id}`)
     setSuggestions(result?.data?.data)
  };

  const handleRemoveUser = (prod) => {
    const updatedItems = selectedItems.filter( (selectedUser) => selectedUser._id !== prod._id)
    setSelectedItems(updatedItems);
    const updatedUsers = new Set(selectedItemSet)
    updatedUsers.delete(prod._id)
    setSelectedItemSet(updatedUsers)
  };

  const detailPage = (id,category) => {
    return Navigate(`/prod/${id}`)
  }

  useEffect(() => {
    // const newSocket = io(SOCKET_ENDPOINT);
    // setSocket(newSocket)
    fetchSearchQuery()
    // return () => newSocket.disconnect();
    return () => fetchSearchQuery()
  }, [searchTerm]);

  // useEffect(() => {
  //   if (!socket) return;

  //   socket.on('chat message', (msg) => {
  //     console.log(msg, ' recieved from thee server');
  //   });

  //   // Clean up listener on unmount
  //   return () => socket.off('chat message');
  // }, [socket]);

  const testing = () => {
    socket.emit('chat message', 'im set');
  }

  async function getprodutsdata() {
    setLoading(true);

    let cat = await axios(`${Baseurl}/category`)
    setCateg(cat.data.data)

    await axios(`${Baseurl}/products`, {
      withCredentials: true,
    })
      .then((resp) => {
        setData(resp.data.data);
        seterror(false);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e.message);
        setLoading(false);

        enqueueSnackbar("Something Failed", { variant: "error" });
        seterror(true);
      });

      let res = await axios.get(`${Baseurl}/deal`)
      setDealdata(res?.data[0])
      setStartDate(res?.data[0]?.startDate)
      setEnddate(res?.data[0]?.endDate)
      let brand = await axios.get(`${Baseurl}/brand`) 
      setBranddata(brand?.data?.data)

      let country = await axios.get(`${Baseurl}/country`)
      setContry(country?.data) 

  }
  async function cartdata(itemid) {
    let data = {
      username: userid,
      products: itemid,
    };
    await axios
      .post(`${Baseurl}/cart`, data, { withCredentials: true })
      .then((resp) => {
        dispatch(cartItem(resp.data.cartlength));
        localStorage.setItem('cart',resp.data.cartlength)
        if (resp.status === 200) {
          return enqueueSnackbar("New Item Added To The Cart", {
            variant: "success",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar(err, { variant: "error" });
      });

      
  }

    // useEffect(() => {
    //     if(endDate){
    //       const interval = setInterval(() => {
    //         const now = new Date().getTime();
    //         const end = new Date(endDate)?.getTime();
    //         const difference = end - now;
            
        
    //         if (difference <= 0) {
    //           clearInterval(interval);
    //           setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    //           return;
    //         }
        
    //         const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    //         const hours = Math.floor(
    //           (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    //         );
    //         const minutes = Math.floor(
    //           (difference % (1000 * 60 * 60)) / (1000 * 60)
    //         );
    //         const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        
    //         setTimeRemaining({ days, hours, minutes, seconds });
    //       }, 1000);
        
    //       return () => clearInterval(interval); }
    //     }, [endDate]);

        const settings2 = {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 5 || 0, // Show all images in one row 
          slidesToScroll: 1,
          arrows: true, // Optional: Add navigation arrows
          responsive: [ // Optional: Adjust responsiveness if needed
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5 || 0,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 5 || 0,
                slidesToScroll: 1,
                initialSlide: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 5 || 0,
                slidesToScroll: 1,
              },
            },
          ],
        };

        // var settings = {
        //   dots: true,
        //   infinite: true,
        //   speed: 100,
        //   slidesToShow: 1,
        //   slidesToScroll: 1,
        // };
     

        var settings1 = {
          dots: false,
          infinite: true ,
          speed: 500,
          slidesToShow: contry?.length || 0, // Show all images in one row 
          slidesToScroll: 1,
          arrows: true, // Optional: Add navigation arrows
          responsive: [ // Optional: Adjust responsiveness if needed
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: contry?.length || 0,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: contry?.length || 0,
                slidesToScroll: 1,
                initialSlide: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: contry?.length || 0,
                slidesToScroll: 1,
              },
            },
          ],
        };


  return (
   <>


<main className="main text-primary">
<Banner />
<section class="section-deals">
<div class="container">
{endDate  ? 
  <div class="deal-block">
    <div class="row">
      <div class="col-md-3">

        <div class="deal-block-left">

<h5>Deals and offers</h5>
<p>Hygiene equipments</p>

<Countdown endDate={endDate} />
{/* 
  <div className="d-flex">
    <div className="digit-box">
      <h6>{String(timeRemaining?.days).padStart(2, '0')}</h6>
      <p>Days</p>
    </div>
    <div className="digit-box">
      <h6>{String(timeRemaining?.hours).padStart(2, '0')}</h6>
      <p>Hours</p>
    </div>
    <div className="digit-box">
      <h6>{String(timeRemaining?.minutes).padStart(2, '0')}</h6>
      <p>Min</p>
    </div>
    <div className="digit-box">
      <h6>{String(timeRemaining?.seconds).padStart(2, '0')}</h6>
      <p>Sec</p>
    </div>
  </div> */}


        </div>

        

      </div>
      <div class="col-md-9">
<div class="row mt-4 mb-4">
{ dealdata?.products?.map((item, index) => {
    return (
      <div className="col-md-3" key={index}>
        <div className="product-box">
          <div className="project-image">
            <img src={`${Baseurl}/view/imageupload/${item?.productId?.img}?t=${new Date().getTime()}`} className="img-fluid" alt="product" />
          </div>
          <div className="product-details">
            <h4>{item?.productId?.name || "Product Name"}</h4>
            <div>
              <span className="price">AED {item?.productId?.mrpprice - item?.discount}</span>
              <span className="crossed-price">AED {item?.productId?.mrprice}</span>
            </div>
            <div className="ratings mb-2 mt-1">
              <img src="/images/icons/gold-star.svg" className="img-fluid" alt="star" />
              <img src="/images/icons/gold-star.svg" className="img-fluid" alt="star" />
              <img src="/images/icons/gold-star.svg" className="img-fluid" alt="star" />
              <img src="/images/icons/gold-star.svg" className="img-fluid" alt="star" />
              <img src="/images/icons/silver-star.svg" className="img-fluid me-2" alt="star" /> 4.2
            </div>
          </div>
        </div>
      </div>
    );
  }) }
</div>

      </div>
      </div>
      </div> : <></> }

    </div>


  </section>

  <section class="section-recomend">

<div class="container">
<div class="row">

<div class="col-md-12">
  <h2>Recommended items</h2>
</div>

</div>

<div class="row">
 
 

  {data?.map((item,index) => {
    return (
      <div class="col-md-3" key={index}>
      <button className="" onClick={()=>detailPage(item._id,item.category?.name)}>
      <div class="product-box" >

<div class="project-image">

  <img src={`${Baseurl}/view/imageupload/${item?.img}?t=${new Date().getTime()}`} class="img-fluid"  />

</div>

<div class="product-details">
  <h4>
    {item?.name}
  </h4>
<div>              <span class="price">AED {item?.ourprice}</span> <span class="crossed-price">AED {item?.mrpprice}</span>
</div>
<div class="ratings mb-2 mt-1">
{[...Array(5)].map((_, i) => (
  <i
    key={i}
    className={`bi bi-star-fill ${
      i < Math.round(item?.averageRating || 0)
        ? 'text-warning' 
        : 'bi-star text-secondary' 
    } me-2`} 
    style={{ fontSize: '1rem' }} 
  ></i>
))} 
{`${Number.isInteger(item?.averageRating) ? item?.averageRating + '.0' : item?.averageRating}`}
</div>
</div>
</div> </button> </div>
    )
  })}

</div>

</div>


  </section>


  <section class="section-delivery-countries">

<div class="container">

  <div class="row">
    <div class="col-md-12">

      <h2><span>Delivery Available Coutries</span> </h2>


    </div>


    <div className="col-md-12">
      <div className="swiper swiper-partners">
        <div className="swiper-wrapper">
          <div className="swiper-slide "> 
            <Slider {...settings1}>
              {contry?.map((item, index) => (
                <div className="d-flex align-items-center" key={index}>
                 <img
                   style={{  width: '40px' }} 
                    class="me-2 "
                    src={`${Baseurl}/view/imageupload/${item?.img}?t=${new Date().getTime()}`}
                    alt="failed"
                  /> <span>{item?.name}</span> 
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
      </div>


    </div>



  </section>

  <section class="section-delivery-countries">

<div class="container">

  <div class="row">
    <div class="col-md-12">

      <h2><span>Brands</span> </h2>


    </div>

    <div className="col-md-12">
      <div className="swiper swiper-partners">
        <div className="swiper-wrapper">
          <div className="swiper-slide"> 

          <div className="swiper-slide "> 
            <Slider {...settings2}>
              {branddata?.map((item, index) => (
                <div className="d-flex justify-content-between " key={index}>
                 <img
                   style={{  width: '60px' }} 
                    className=""
                    src={`${Baseurl}/view/imageupload/${item?.img}?t=${new Date().getTime()}`}
                    alt="failed"
                  /> 
                </div>
              ))}
            </Slider>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


  </section>

</main>




<Tempfooter />










    <section className="container-fluid" >
    <div className="row">
 
    </div>

    <hr />
        {/* <div className='row pb-2'>
          <div className='col-sm-12'>
            <div className='fs-2'>
            <button onClick={testing}>hhh</button>
              <p>Related Poducts</p>
            </div>
            <div className='d-flex gap-3 flex-wrap  justify-content-center  align-items-center pb-3'>
  {
    data?.map((item,index) => {
      return (
     <div key={item._id}>
      <div className="card" style={{width: '15rem',height:'19rem'}}>
  <button className="" onClick={()=>detailPage(item._id,item.category?.name)}>
    <div><img style={{width:'138px', height:'150px',borderRadius:'5px'}} src={`${Baseurl}/view/imageupload/${item.img}`} /></div>
    { item.type === 'old' ?<div className='border text-center p-1 bg-info'>OLD</div> :''}
    { item.type === 'refurbmished' ?<div className='border text-center p-1 bg-danger'>REFURBMISHED</div> :''}
    { item.type === 'brandnew' ?<div className='border text-center p-1 bg-success'>BRAND NEW</div> :''}
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center p-1 text-nowrap bg-light w-100'>{item.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center pb-1 text-nowrap bg-light w-100'>{item?.brand?.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center p-1 text-nowrap bg-light w-100'>{item.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center  text-nowrap bg-light w-100 d-flex justify-content-center gap-1'>
    <span><del>{item.mrprice}</del></span> <span>{item.ourprice}</span></div> 

  </button>
</div>
        </div>
      )
    })
  }
</div>
          </div>
        </div> */}

    </section>
   </>
  )
};

export default Products;
